<template>
  <div>
    <b-table small striped hover
      @row-clicked="rowTurboModeClickHandler"
      :items="turboSettings"
      :fields="fieldsTurboSettings">
    </b-table>
    <b-row>
      <b-col>
        <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="saveTurboMode">Ok</b-button>
      </b-col>
      <b-col sm="1.5">
        <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideTurboMode">{{ $t('Cancel') }}</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import axiosInstance from '@/utils/api.js'

export default {
  props: {
    currentService: null
  },
  data () {
    return {
      turbo: {
        'slink_id': 0,
        'turbomode_settings_id': 0
      },
      selectedTurboMode: null,
      turboSettings: [],
      fieldsTurboSettings: [
        {key: 'incoming_rate', label: this.$i18n.t('Incoming'), sortable: true, formatter: 'incomingRate'},
        {key: 'incoming_limit', label: this.$i18n.t('Incoming limit'), sortable: true, formatter: 'incomingLimit'},
        {key: 'outgoing_rate', label: this.$i18n.t('Outgoing'), sortable: true, formatter: 'outgoingRate'},
        {key: 'outgoing_limit', label: this.$i18n.t('Outgoing limit'), sortable: true, formatter: 'outgoingLimit'},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true}
      ]
    }
  },
  methods: {
    async load () {
      let turboSettings = await axiosInstance.get(this.$store.getters.API_SETTINGS_SHAPING + '?service_id=' + this.currentService.service_id).then(response => { return response.data })
      this.turboSettings = turboSettings.settings
    },
    hideTurboMode () {
      this.$emit('hideTurboMode')
    },
    rowTurboModeClickHandler (row) {
      if (this.selectedTurboMode) {
        this.selectedTurboMode._rowVariant = ''
      }
      this.selectedTurboMode = row
      this.$set(this.selectedTurboMode, '_rowVariant', 'info')
    },
    saveTurboMode () {
      if (this.selectedTurboMode) {
        this.turbo.slink_id = this.currentService.service_link_id
        this.turbo.turbomode_settings_id = this.selectedTurboMode.settings_id
        axiosInstance.post(this.$store.getters.API_USERS_SERVICELINKS_ENABLE_TURBO_MODE, this.turbo).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$emit('hideTurboMode')
            this.$root.$emit('makeToasts')
          }
        })
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select turbo mode'), 'Error')
      }
    },
    incomingRate (value) {
      if (value === -1) {
        return 'Unlimited'
      } else if (value === 0) {
        return 'Disabled'
      } else {
        return value
      }
    },
    incomingLimit (value) {
      if (value === 0) {
        return 'Not set'
      } else {
        return value
      }
    },
    outgoingRate (value) {
      if (value === 0) {
        return 'Disabled'
      } else {
        return value
      }
    },
    outgoingLimit (value) {
      if (value === 0) {
        return 'Not set'
      } else {
        return value
      }
    }
  },
  mounted () {
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/formTurboMode.vue